import { gql } from '@apollo/client';

export const GET_PROPOSALS_FOR_HUB_TABLE_BY_ACCOUNT_PAGINATED = gql`
  query ProposalsForHubTableByAccountPaginated($input: ProposalsWithPaginationInput!) {
    proposals: proposalsByAccountWithPagination(input: $input) {
      page
      total
      perPage
      totalPages
      data {
        id
        status
        saleType
        lastName
        fullName
        firstName
        businessName
        salesPersonName
        createdDateTime
        amountRequested
        vendorOpportunityId
        vendorOpportunity {
          paymentType
          applicationStage
          salesRepresentative {
            firstName
            lastName
            fullName
          }
          financeManager {
            firstName
            lastName
            fullName
          }
          location {
            locationName
          }
          equipments {
            newUsed
          }
        }
      }
    }
  }
`;
